var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
var Generic = /** @class */ (function (_super) {
    __extends(Generic, _super);
    function Generic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Generic.prototype.render = function () {
        return (_jsx("div", { className: 'scores_baord' }));
    };
    return Generic;
}(React.Component));
export default Generic;



// WEBPACK FOOTER //
// ./src/components/grid/event/statistics/Generic.jsx